import React from 'react';
import { Button, Popconfirm, Tooltip } from 'antd';
import { DeleteOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';

function ContentItemActions({
  t,
  type,
  url,
  largeThumb,
  smallThumb,
  onShow,
  onDelete,
  onError,
}) {
  const showButton = (
    <Button
      className="content-item__actions-btn"
      onClick={onShow}
      icon={<EyeOutlined width={21} height={15} />}
      type="link"
      ghost
    />
  );

  return (
    <div className="content-item__actions">
      {type === 'url' ? (
        <Tooltip
          title={
            <div className="text-center">
              <div>{t('go-to')}</div>
              <div>{url}</div>
            </div>
          }
          placement="top"
        >
          <a className="ant-btn-background-ghost" href={url} target="_blank">
            <EyeOutlined width={21} height={15} />
          </a>
        </Tooltip>
      ) : (
        showButton
      )}
      {type !== 'url' && (url || largeThumb || smallThumb) && (
        <Button
          className="content-item__actions-btn"
          icon={<UploadOutlined width={21} height={21} rotate={180} />}
          type="link"
          ghost
          href={url || largeThumb || smallThumb}
          target="_blank"
        />
      )}
      <Popconfirm
        placement="topRight"
        title={t('delete-content-warning')}
        cancelText={t('to-leave')}
        okText={t('delete')}
        onConfirm={onDelete}
      >
        <Button
          className="content-item__actions-btn"
          size="sm"
          icon={<DeleteOutlined width={21} height={20} />}
          type="link"
          ghost
        />
      </Popconfirm>
    </div>
  );
}

export default ContentItemActions;
